import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import AppSecureStorage from '../../../services/storage/secureStorage';
import { message } from 'antd';
import { setUserProfile } from '../../Global/globalSlice';
// import { unauthorizedError } from '../../../utils/helpers';
import organizationInfoService from '../../../services/api/Organization/organizationInfoService';
import { get_organization } from '../OrgAuth/OrgAuthSlice';
import jobService from '../../../services/api/Organization/JobService';
const orgInfo = new organizationInfoService();
const jobInfo = new jobService();
const storage = new AppSecureStorage();

export const Update_organization = createAsyncThunk(
    "org/Update_organization",
    async ({ body, navigate, onClose }, { dispatch }) => {
        dispatch(setUserProfileLoad(true))
        try {
            const response = await orgInfo.Update_organization(body)
            dispatch(get_organization(navigate))
            message.success("Profile updated Successfully")
            onClose()
            if (response) {
                dispatch(setUserProfileLoad(false));
            }
            return response.data
        } catch (error) {
            // if (error?.response && error?.response?.status === 401) {
            //     dispatch(setUserProfile({}))
            //     unauthorizedError(navigate)
            // } else {
                dispatch(setUserProfileLoad(false))
                error?.response?.data?.error && message.error(error?.response?.data?.error)
                const [{ msg }] = error.response.data
                message.error(msg);
            // }
        }
    }
);

export const remove_organization = createAsyncThunk(
    "org/remove_organization",
    async (navigate, { dispatch }) => {
        dispatch(setRemoveLoad(true))
        try {
            const response = await orgInfo.Remove_organization()
            message.success("Organization Removed Successfully");
            navigate("/");
            storage.clearStorage();
            return response.data
        } catch (error) {
            // if (error?.response && error?.response?.status === 401) {
            //     dispatch(setUserProfile({}))
            //     unauthorizedError(navigate)
            // } else {
                dispatch(setRemoveLoad(false))
                error?.response?.data?.error && message.error(error?.response?.data?.error)
                const [{ msg }] = error.response.data
                message.error(msg);
            // }
        }
    }
);

export const add_organization_roles = createAsyncThunk(
    "org/add_organization_roles",
    async ({ body, navigate }, { dispatch }) => {
        dispatch(setAddRoleLoad(true))
        try {
            const response = await orgInfo.Add_organization_Roles(body)
            dispatch(get_organization(navigate))
            message.success("role added Successfully")
            return response.data
        } catch (error) {
            // if (error?.response && error?.response?.status === 401) {
            //     dispatch(setUserProfile({}))
            //     unauthorizedError(navigate)
            // } else {
                dispatch(setAddRoleLoad(false))
                error?.response?.data?.error && message.error(error?.response?.data?.error)
                const [{ msg }] = error.response.data
                message.error(msg);
            // }
        }
    }
);

export const Schedule_Meet = createAsyncThunk(
    "org/Schedule_Meet",
    async ({ body, navigate, onClose }, { dispatch }) => {
        dispatch(setMeetLoad(true))
        try {
            const response = await orgInfo.Schedule_Meet(body)
            dispatch(get_organization(navigate))
            message.success("Meeting scheduled Successfully")
            onClose()
            dispatch(setMeetLoad(false));
            return response.data
        } catch (error) {
            // if (error?.response && error?.response?.status === 401) {
            //     dispatch(setUserProfile({}))
            //     unauthorizedError(navigate)
            // } else {
                dispatch(setMeetLoad(false))
                error?.response?.data?.error && message.error(error?.response?.data?.error)
                const [{ msg }] = error.response.data
                message.error(msg);
            // }
        }
    }
);

export const get_organization_jobs = createAsyncThunk(
    "org/get_organization_jobs",
    async ({ navigate, searchParams = "", status }, { dispatch }) => {
        dispatch(setOrgLoad(true))
        try {
            const response = await orgInfo.Get_organization_jobs(searchParams, status);
            dispatch(get_organization(navigate));
            dispatch(setOrgLoad(false));
            dispatch(setOrgnizationJobs(response?.data))
            return response.data
        } catch (error) {
            // if (error?.response && error?.response?.status === 401) {
            //     dispatch(setUserProfile({}))
            //     unauthorizedError(navigate)
            // } else {
                dispatch(setOrgLoad(false))
                error?.response?.data?.error && message.error(error?.response?.data?.error)
                const [{ msg }] = error.response.data
                message.error(msg);
            // }
        }
    }
);

export const get_audits_details = createAsyncThunk(
    "org/get_audits_details",
    async ({ navigate }, { dispatch }) => {
        dispatch(setAuditSLoad(true))
        try {
            const response = await orgInfo.Get_audits()
            dispatch(setAuditSLoad(false));
            dispatch(setAuditDetails(response?.data))
            return response.data
        } catch (error) {
            // if (error?.response && error?.response?.status === 401) {
            //     dispatch(setUserProfile({}))
            //     unauthorizedError(navigate)
            // } else {
                dispatch(setAuditSLoad(false))
                error?.response?.data?.error && message.error(error?.response?.data?.error)
                error?.response?.data?.forEach((err) => {
                    message.error(`${err.msg} of ${err?.path}`);
                });
            // }
        }
    }
);

export const get_shortlisted_candidate = createAsyncThunk(
    "org/get_shortlisted_candidate",
    async ({ navigate, searchParams = "", status = "" }, { dispatch }) => {
        dispatch(setShortLoad(true))
        try {
            const response = await jobInfo.ShortListed_Candidate()
            dispatch(setShortLoad(false));
            dispatch(setShortListedCandidate(response?.data?.data))
            return response.data
        } catch (error) {
            // if (error?.response && error?.response?.status === 401) {
            //     dispatch(setUserProfile({}))
            //     unauthorizedError(navigate)
            // } else {
                dispatch(setShortLoad(false))
                error?.response?.data?.error && message.error(error?.response?.data?.error)
                const [{ msg }] = error.response.data
                message.error(msg);
            // }
        }
    }
);

export const send_interview_dates = createAsyncThunk(
    "org/send_interview_dates",
    async ({ navigate, body }, { dispatch }) => {
        dispatch(setDateLoad(true))
        try {
            const response = await jobInfo.Send_interview_dates(body)
            dispatch(setDateLoad(false));
            return response.data
        } catch (error) {
            // if (error?.response && error?.response?.status === 401) {
            //     dispatch(setUserProfile({}))
            //     unauthorizedError(navigate)
            // } else {
                dispatch(setDateLoad(false))
                error?.response?.data?.error && message.error(error?.response?.data?.error)
                const [{ msg }] = error.response.data
                message.error(msg);
            // }
        }
    }
);

export const update_organization_job_status = createAsyncThunk(
    "org/update_organization_job_status",
    async ({ navigate, jobId, body, filters }, { dispatch }) => {
        dispatch(setUpStatusLoad(true))
        try {
            const response = await orgInfo.Update_organizationjob_status(jobId, body);
            dispatch(get_organization_jobs({ navigate, searchParams: "", status: body?.status, searchParams: filters }));
            dispatch(setChangesStatus(body?.status))
            dispatch(get_organization(navigate))
            dispatch(setUpStatusLoad(false));
            return response.data
        } catch (error) {
            // if (error?.response && error?.response?.status === 401) {
            //     dispatch(setUserProfile({}))
            //     unauthorizedError(navigate)
            // } else {
                dispatch(setUpStatusLoad(false))
                error?.response?.data?.error && message.error(error?.response?.data?.error)
                const [{ msg }] = error.response.data
                message.error(msg);
            // }
        }
    }
);

export const google_activate_api = createAsyncThunk(
    "org/google_activate_api",
    async ({ navigate }, { dispatch }) => {
        dispatch(setGoogleActivationload(true))
        try {
            const response = await jobInfo.Activate_google_meet();
            get_organization_jobs({ navigate, searchParams: "", status: "" });
            dispatch(setGoogleActivationload(false));
            return response.data
        } catch (error) {
            // if (error?.response && error?.response?.status === 401) {
            //     dispatch(setUserProfile({}))
            //     unauthorizedError(navigate)
            // } else {
                dispatch(setGoogleActivationload(false))
                error?.response?.data?.error && message.error(error?.response?.data?.error)
                const [{ msg }] = error.response.data
                message.error(msg);
            // }
        }
    }
);

export const get_specific_job_status = createAsyncThunk(
    "org/get_specific_job_status",
    async ({ navigate, jobId }, { dispatch }) => {
        dispatch(setJobSLoad(true))
        try {
            const response = await orgInfo.Get_job_by_Id(jobId);
            dispatch(setJobSLoad(false));
            dispatch(setSpecificJobDetails(response?.data))
            return response.data
        } catch (error) {
            // if (error?.response && error?.response?.status === 401) {
            //     dispatch(setUserProfile({}))
            //     unauthorizedError(navigate)
            // } else {
                dispatch(setJobSLoad(false))
                error?.response?.data?.error && message.error(error?.response?.data?.error)
                const [{ msg }] = error.response.data
                message.error(msg);
            // }
        }
    }
);

const initialState = {
    userProfileLoad: false,
    loading: false,
    removeLoad: false,
    addRoleLoad: false,
    meetLoad: false,
    organizationJobs: [],
    OrgLoad: false,
    shortlistedCandidates: [],
    shortLoad: false,
    sendDateload: false,
    updateStatusload: false,
    googleactivationlad: false,
    specificJobDetails: {},
    jobSload: false,
    auditload: false,
    auditDetails: [],
    changesStatus: 'open'
};

const orgInfoSlice = createSlice({
    name: 'orgInfo',
    initialState,
    reducers: {
        setUserProfileLoad: (state, action) => {
            state.userProfileLoad = action.payload
        },
        setRemoveLoad: (state, action) => {
            state.removeLoad = action.payload
        },
        setAddRoleLoad: (state, action) => {
            state.addRoleLoad = action.payload
        },
        setMeetLoad: (state, action) => {
            state.meetLoad = action.payload
        },
        setOrgnizationJobs: (state, action) => {
            state.organizationJobs = action.payload
        },
        setOrgLoad: (state, action) => {
            state.OrgLoad = action.payload
        },
        setShortLoad: (state, action) => {
            state.shortLoad = action.payload
        },
        setShortListedCandidate: (state, action) => {
            state.shortlistedCandidates = action.payload
        },
        setDateLoad: (state, action) => {
            state.sendDateload = action.payload
        },
        setUpStatusLoad: (state, action) => {
            state.updateStatusload = action.payload
        },
        setGoogleActivationload: (state, action) => {
            state.googleactivationlad = action.payload
        },
        setSpecificJobDetails: (state, action) => {
            state.specificJobDetails = action.payload
        },
        setJobSLoad: (state, action) => {
            state.jobSload = action.payload
        },
        setAuditSLoad: (state, action) => {
            state.auditload = action.payload
        },
        setAuditDetails: (state, action) => {
            state.auditDetails = action.payload
        },
        setChangesStatus: (state, action) => {
            state.changesStatus = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(Update_organization.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(Update_organization.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(Update_organization.rejected, (state, action) => {
                state.loading = false;
            })

            .addCase(remove_organization.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(remove_organization.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(remove_organization.rejected, (state, action) => {
                state.loading = false;
            })

            .addCase(add_organization_roles.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(add_organization_roles.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(add_organization_roles.rejected, (state, action) => {
                state.loading = false;
            })

            .addCase(Schedule_Meet.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(Schedule_Meet.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(Schedule_Meet.rejected, (state, action) => {
                state.loading = false;
            })

            .addCase(get_organization_jobs.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(get_organization_jobs.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(get_organization_jobs.rejected, (state, action) => {
                state.loading = false;
            })
    }
});

export const
    { setUserProfileLoad, setAddRoleLoad, setRemoveLoad, setMeetLoad, setOrgnizationJobs, setOrgLoad,
        setShortListedCandidate, setShortLoad, setDateLoad, setUpStatusLoad, setGoogleActivationload,
        setSpecificJobDetails, setJobSLoad, setAuditDetails, setAuditSLoad, setChangesStatus
    } = orgInfoSlice.actions;
export default orgInfoSlice.reducer;
